export default __webpack_public_path__ + "static/media/Captain's Belt of Heaven's Pass.84512178.jpg";